
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SectorAirServicesComponent } from './sector-air-services.component';
import { ServicesTableModule } from '../../shared/components/services-table/services-table.module';
import { SectorAirServicesServiceModule } from '../../shared/services/sector-air-services/sector-air-services.module';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { TableServicesServiceModule } from '../../shared/services/table-services/table-services.module';

@NgModule({
    imports: [
        CommonModule,
        ServicesTableModule,
        SectorAirServicesServiceModule,
        TableServicesServiceModule,
        NotificationModule,
    ],
    exports: [
        SectorAirServicesComponent,
    ],
    declarations: [
        SectorAirServicesComponent,
    ]
})
export class SectorAirServicesModule { }
